import script from "./MomentMiniature.vue?vue&type=script&setup=true&lang=js"
export * from "./MomentMiniature.vue?vue&type=script&setup=true&lang=js"

import "./MomentMiniature.vue?vue&type=style&index=0&id=abb4f62c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-abb4f62c"]])

export default __exports__